import { string } from 'yup';

export const IdSchema = string().required().min(1);
